<ng-container [caLocalizationScope]="localizationKey">
  <i
    *ngIf="showPopover$ | async"
    fMobilePopover
    [ngbPopover]="isFundsInfo ? tooltipFundsOnly : tooltipContent"
    triggers="hover focus"
    container="body"
    class="f-i f-i-info text-muted cursor-default"
    [ngClass]="'f-i-' + iconSize"
  >
  </i>

  <ng-template #tooltipContent>
    <div class="mb-1">{{ 'tooltipInfoTitle' | caLocalize }}</div>
    <div class="mb-1">{{ 'tooltipInfoInstitutions' | caLocalize }}</div>
    <div>{{ 'tooltipInfoFunds' | caLocalize }}</div>
  </ng-template>

  <ng-template #tooltipFundsOnly>
    <div>{{ 'tooltipInfoFundsOnly' | caLocalize }}</div>
  </ng-template>
</ng-container>
